<script setup lang="ts">
import SvgIllustration from '@/vue/atoms/svg-illustration.vue';

defineProps<{
  count: number;
  subtitle: string;
  selected?: boolean;
  inactive?: boolean;
}>();

const emit = defineEmits<{
  click: [];
}>();

function handleClick(): void {
  emit('click');
}
</script>

<template>
  <button
    class="summary-box"
    :class="{selected, inactive}"
    type="button"
    @click="handleClick"
  >
    <span class="count">{{ count }}</span>
    <div class="bottom-row">
      <span class="subtitle">{{ subtitle }}</span>
      <svg-illustration name="shevron.svg"/>
    </div>
  </button>
</template>

<style lang="scss" scoped>
.summary-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--Spacing-spacing-4);
  background: transparent;
  border-radius: var(--card-border-radius);
  border: none;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.2s ease;

  &:hover:not(.inactive) {
    background: var(--Neutral-UI-neutral-ui-10);
  }

  &.inactive {
    cursor: default;
  }

  &.selected {
    background: var(--Neutral-UI-neutral-ui-10);
  }
}

.count {
  @include font-metric-lg;
  color: var(--Neutral-UI-neutral-ui-100);
}

.bottom-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: var(--Neutral-UI-neutral-ui-100);
}

.subtitle {
  @include font-body-sm;
  color: var(--Neutral-UI-neutral-ui-100);
}
</style>
